import { setProduct } from '../reducers/products';

const fetchProduct = (product) => (dispatch) => {
  dispatch(setProduct(product));
  return Promise.resolve(product);
};

const productActions = {
  fetchProduct,
};

export default productActions;
